"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingModal = void 0;
const SmartPricingRecapData_1 = require("../pricing-smart-recap/SmartPricingRecapData");
const hui_1 = require("@travelnest/hui");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const index_1 = require("../../../index");
const react_1 = require("react");
const pricing_helpers_1 = require("../../../util/pricing_helpers");
const styled_1 = __importDefault(require("@emotion/styled"));
const localStorage_1 = __importDefault(require("../../../hooks/localStorage"));
const helpers_1 = require("../../pages/tasks/pricing/helpers");
const calendar_with_prices_svg_1 = __importDefault(require("../../../71eb904/assets/images/smart-pricing/calendar-with-prices.svg"));
const react_dom_1 = require("react-dom");
const ModalContent = styled_1.default.div `
	display: flex;
  	flex-direction: column;
	align-items: center;
	text-align: center;
	justify-content: center;
	width: 100%;
`;
// @ts-ignore
const Title = styled_1.default.p `
	${hui_1.theme.typography.RWB130};
	font-weight: 700;
	text-align: center;
	color: #11233A;
`;
// @ts-ignore
const Description = styled_1.default.p `
	${hui_1.theme.typography.IR100};
	margin-top: 16px;
	margin-bottom: 24px;
	line-height: 150%;
`;
// @ts-ignore
const Note = styled_1.default.p `
	${hui_1.theme.typography.IR100};
	margin-top: 16px;
	margin-bottom: 32px;
	line-height: 150%;
`;
const SmartPricingRecapDataWrapper = styled_1.default.div `
	width: 100%;
	padding: 0 24px;
`;
const DisabledSmartPricingImage = styled_1.default.img `
	height: 228px;
	width: 100%;
	margin-bottom: 48px;
`;
/**
 * This component is used to display the onboarding modal for smart pricing.
 * If the user doesn't use smart pricing then we don't show this modal and neither we trigger any API call.
 * We use the local storage to store if this modal has been seen, this way we only show it once.
 */
const OnboardingModal = (props) => {
    const { entityActions, appMode } = (0, react_1.useContext)(index_1.AppContext);
    const pricingType = (0, react_redux_1.useSelector)((state) => state.data.pricingType.byPropertyId[props.propertyId]);
    const pricingDefaults = (0, react_redux_1.useSelector)((state) => state.data.pricingDefaults.byPropertyId[props.propertyId]);
    const smartPricing = (0, react_redux_1.useSelector)((state) => state.data.pricingAutomaticPrices.byPropertyId[props.propertyId]);
    const property = (0, react_redux_1.useSelector)((state) => state.data.properties.byId[props.propertyId]);
    const [showSmartPricingModal, setShowSmartPricingModal] = React.useState(false);
    const [hasSeenOnboardingModal, setHasSeenOnboardingModal] = (0, localStorage_1.default)('seenOnboardingModal', 'false');
    const dispatch = (0, react_redux_1.useDispatch)();
    const smartPricingTutorialLink = 'https://travelnest.freshdesk.com/support/solutions/articles/101000467596-smart-pricing';
    // If smart pricing is enabled and have not seen the modal yet, then we trigger the API call to get the data.
    React.useEffect(() => {
        if (!smartPricing && (pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) === 'automatic' && hasSeenOnboardingModal === 'false') {
            dispatch(entityActions.pricingAutomaticPrices.getByPropertyId(props.propertyId));
        }
    }, []);
    // If smart pricing is not enabled then we want to show the modal only if region is supported, we are on onboarding, and we haven't seen it before.
    React.useEffect(() => {
        const checkRegionSupport = () => __awaiter(void 0, void 0, void 0, function* () {
            const { id, latitude, longitude } = property;
            (0, helpers_1.fetchSmartPricingRegionCheck)(id, latitude, longitude)
                .then((resp) => setShowSmartPricingModal(resp.in_market))
                .catch((err) => console.error(err));
        });
        if ((pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) !== 'automatic' && appMode === 'onboard' && hasSeenOnboardingModal === 'false') {
            checkRegionSupport();
        }
    }, []);
    // If the smart pricing is there, and we are doing onboarding and the modal has not been seen yet then we show it
    React.useEffect(() => {
        if (smartPricing && (pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) === 'automatic' && appMode === 'onboard' && hasSeenOnboardingModal === 'false') {
            setShowSmartPricingModal(true);
        }
    }, [smartPricing]);
    const onCloseClicked = () => {
        setHasSeenOnboardingModal('true');
        setShowSmartPricingModal(false);
    };
    // We use the modal as a createPortal to make sure is on top of navigation and other elements
    return (0, react_dom_1.createPortal)(React.createElement(hui_1.Modal, { show: showSmartPricingModal, onBackgroundClick: onCloseClicked, closeButton: {
            onClick: onCloseClicked
        }, actionButton: {
            text: 'Continue to setup',
            onClick: onCloseClicked,
        }, position: 'fixed' },
        React.createElement(ModalContent, null,
            (pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) === 'automatic' &&
                React.createElement(React.Fragment, null,
                    React.createElement(Title, null, "You\u2019ve got Smart Pricing!"),
                    React.createElement(Description, null, "Smart Pricing scans the demand in your area to ensure that you always have the most competitive rates for your property."),
                    React.createElement(SmartPricingRecapDataWrapper, null,
                        React.createElement(SmartPricingRecapData_1.SmartPricingRecapData, { recapData: (0, pricing_helpers_1.calculateSmartPricingStats)(smartPricing, pricingDefaults, []), currency: (pricingDefaults === null || pricingDefaults === void 0 ? void 0 : pricingDefaults.currency) || 'GBP' })),
                    React.createElement(Note, null,
                        React.createElement("a", { href: smartPricingTutorialLink }, "Find out more"),
                        " about how Smart Pricing works")),
            (pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) !== 'automatic' &&
                React.createElement(React.Fragment, null,
                    React.createElement(DisabledSmartPricingImage, { src: calendar_with_prices_svg_1.default }),
                    React.createElement(Title, null, "Smart prices and even smarter results"),
                    React.createElement(Description, null,
                        "Save time and enjoy effortless pricing. Smart pricing helps you make ",
                        React.createElement("b", null, "up to 60% more"),
                        "in revenue by automatically adjusting prices according to local market trends."),
                    React.createElement(Note, null,
                        React.createElement("a", { href: smartPricingTutorialLink }, "Find out more"),
                        " about how Smart Pricing works")))), document.body);
};
exports.OnboardingModal = OnboardingModal;
//# sourceMappingURL=OnboardingModal.js.map